import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => (
  <Box
    component="footer"
    sx={{ mt: 6, pt: 2, borderTop: 1, borderColor: 'divider', display: 'flex', justifyContent: 'center' }}
  >
    <Typography
      component="span"
      sx={(theme) => ({
        fontSize: '0.75rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        color: theme.palette.mode === 'dark' ? '#e3b341' : '#b8860b',
      })}
    >
      © {new Date().getFullYear()} PlanGo.Today
    </Typography>
  </Box>
);

export default Footer;
